import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TravelCashAdvanceListComponent } from './components/travel-cash-advance-list/travel-cash-advance-list.component';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule, MatAutocompleteModule, MatCheckboxModule, MatButtonModule, MatFormFieldModule, MatTabsModule, MatSelectModule, MatDatepickerModule, MatIconModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TravelCashService } from './services/travel-cash/travel-cash.service';
import { TravelCashAdvanceAddComponent } from './components/travel-cash-advance-add/travel-cash-advance-add.component';
import { TravelCashAdvanceViewComponent } from './components/travel-cash-advance-view/travel-cash-advance-view.component';
import { TravelCashApproveListComponent } from './components/travel-cash-approve-list/travel-cash-approve-list.component';
import { TravelCashAdvanceCancelComponent } from './components/travel-cash-advance-cancel/travel-cash-advance-cancel.component';
import { TravelCashApproverComponent } from './components/travel-cash-approver/travel-cash-approver.component';
import { TravelCashApproverViewerComponent } from './components/travel-cash-approver-viewer/travel-cash-approver-viewer.component';

@NgModule({
  declarations: [
    TravelCashAdvanceListComponent,
    TravelCashAdvanceAddComponent,
    TravelCashAdvanceViewComponent,
    TravelCashApproveListComponent,
    TravelCashAdvanceCancelComponent,
    TravelCashApproverComponent,
    TravelCashApproverViewerComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTabsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule
  ],
  exports: [
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule
  ],
  providers:[    
    TravelCashService
  ],
  entryComponents:[
    TravelCashAdvanceAddComponent,
    TravelCashAdvanceViewComponent,
    TravelCashApproveListComponent,
    TravelCashAdvanceCancelComponent,
    TravelCashApproverViewerComponent
  ]
})
export class TravelCashAdvanceModule { }
